import { types, Instance, flow, getEnv } from "mobx-state-tree";

import { Endpoint, endpoints } from "../api/ApiEndpoints";
import { StorageModel } from "../storage/StorageModel";
import { permissionsService } from "../authorization/UserPermissionsService";
import { ViewSewerObject, ViewSewerObjectFromAssignedProject } from "../authorization/Permissions";
import { NodeDetailsResponse } from "../../api-models/response/NodeDetailsResponse";
import { NodeDetails } from "./NodeDetails";
import { CurrentSewerObjectStorageModel } from "../storage/CurrentSewerObjectStorageModel";

const CurrentNodeModel = types.model({
  nodeId: types.frozen<number>(),
  currentNode: types.optional(types.frozen<NodeDetails>(), new NodeDetails()),
  isDeleteInProgress: types.optional(types.boolean, false),
});

export const CurrentNodeStorageModel = types
  .compose(CurrentNodeModel, CurrentSewerObjectStorageModel, StorageModel)
  .named("CurrentNodeStorage")
  .actions((self) => {
    return {
      mapResponse(response: NodeDetailsResponse) {
        const node = new NodeDetails(response);
        self.currentNode = node;
      },
      delete: flow(function* () {
        self.isDeleteInProgress = true;
        const endpoint = endpoints.get("node");
        endpoint.routeParams = [self.nodeId];
        const response = yield getEnv(self).api.delete(endpoint);
        self.isDeleteInProgress = false;
        return response;
      }),
    };
  })
  .views((self) => ({
    get nodeIsLoaded() {
      return self.currentNode.id > 0;
    },

    get endpoint() {
      const endpoint: Endpoint = endpoints.get("node");
      endpoint.routeParams = [self.nodeId];
      return endpoint;
    },

    get canUserViewNode() {
      return (
        permissionsService.userHasPermissionTo(ViewSewerObject) ||
        permissionsService.userHasPermissionTo(ViewSewerObjectFromAssignedProject)
      );
    },
  }))
  .views((self) => ({
    get canLoadItems() {
      return self.canUserViewNode && self.nodeId > 0;
    },
    get isLoading() {
      return !self.nodeIsLoaded;
    },
  }));

export type CurrentNodeStorage = Instance<typeof CurrentNodeStorageModel>;
